import { ReportType } from '../enums';

export interface ReportBatch {
  idRelatorioGeral: number;
  dataCriacao: string;
  filtro: string;
  tipo: ReportType;
  status: string;
  nomeFundo: string;
  cnpjFundo: string
  usuario: string;
  pathArquivo: string;
}
